export function view(value) {
  return value ? 'Inbound' : 'Outbound'
}
